import React from 'react';
import { StyleSheet, ScrollView, Text } from 'react-native';
import { ListItem } from '@rneui/themed';
import { AntDesign } from '@expo/vector-icons';

import FormField from '../form/FormField';
import CheckBoxItemForm from './CheckBoxItemForm';
import { layoutTokens } from '../tokens/layout';

const styles = StyleSheet.create({
  container: layoutTokens.fullWidth,
});

interface Props {
  value: any;
  title?: string;
  tableList: Array<{
    type_id: string;
    name: string;
    description: string;
    image: string;
    id?: string;
  }>;
  setFieldValue: (item: any) => void;
  disabled: boolean;
}

const CheckBoxItemListForm: React.FC<Props> = ({
  value,
  title,
  tableList,
  setFieldValue = null,
  disabled = false,
}) => {
  const [expanded, setExpanded] = React.useState(false);

  return (
    <ListItem.Accordion
      content={
        <ListItem.Content>
          <ListItem.Title>
            <Text>{title}</Text>
          </ListItem.Title>
        </ListItem.Content>
      }
      isExpanded={expanded}
      onPress={() => {
        setExpanded(!expanded);
      }}
      icon={<AntDesign name="up" size={24} color="black" />}
      style={styles.container}
      disabledStyle={{ backgroundColor: 'lightgray' }}
      disabled={disabled}
    >
      <ScrollView>
        {tableList.map((item, key) => (
          <CheckBoxItemForm
            value={value}
            item={item}
            key={key}
            setFieldValue={setFieldValue}
          />
        ))}
      </ScrollView>
    </ListItem.Accordion>
  );
};

export default FormField(CheckBoxItemListForm);
